import React, { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useMediaQuery } from "react-responsive";
import { NewsThumbCard } from "@modules/study/common/news";
import { ReactSVG } from "react-svg";
import { getAssets, objectToQueryString } from "@unisearch/helpers";
import {
  NewsPopular,
  NewsSearch,
  NewsSubscription,
  NewsTags,
} from "@modules/study/common/news";
import NewsMap from "./map";

import styles from "./list_section.module.scss";

const mapCountries = ["AU", "CA", "IE", "NZ", "GB", "US"];

export const NewsListSection = ({
  letestNews,
  popularStories,
  tagsList,
  format,
  newsCountry = [],
}) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 900px)",
  });
  const router = useRouter();

  const pushToLatestNews = () => {
    let query = objectToQueryString({ limit: 8, page: 1 });
    router.push({
      pathname: "/news/letest",
      query: query,
    });
    return true;
  };

  const pushToCountryNews = (countrySlug) => {
    let query = objectToQueryString({ limit: 8, page: 1, countrySlug });
    router.push({
      pathname: "/news/country",
      query: query,
    });
    return true;
  };

  return (
    <section>
      <div className="container">
        <div className={styles.list_wrapper}>
          <div className={styles.left_side}>
            {isMobile && <NewsSearch />}
            {letestNews && letestNews?.length > 0 && (
              <>
                <h2 className={styles.title}>Letest News</h2>
                <div className={styles.list}>
                  {letestNews &&
                    letestNews.map((news, i) => (
                      <NewsThumbCard key={i} data={news} />
                    ))}
                </div>

                {letestNews && letestNews?.length > 5 && (
                  <div className={styles.btn_view_all}>
                    <button
                      onClick={pushToLatestNews}
                      className={`btn btn-secondary btn-md`}
                    >
                      View All
                    </button>
                  </div>
                )}
              </>
            )}

            {/* browse_by_region_wrapper */}
            {newsCountry?.length > 0 && (
              <div className={styles.browse_by_region_wrapper}>
                <div className={styles.browse_by_title_wrapper}>
                  <h2 className={styles.browse_by_title}>
                    Browse Articles by Region
                  </h2>
                  <div>You can find article using by map</div>
                </div>

                <div className={styles.browse_by_map_wrapper}>
                  <div className={styles.map_wrapper}>
                    {/* <NewsMap /> */}
                    <img
                      src={getAssets(
                        "assets/images/news/browse-by-country.png"
                      )}
                      alt="Map"
                    />
                    {newsCountry &&
                      newsCountry.map((item, i) => {
                        if (mapCountries.includes(item.shortName)) {
                          return (
                            <div
                              onClick={() => pushToCountryNews(item.slug)}
                              key={`${i}mapmarker`}
                              className={`${styles.location_on_wrapper} ${
                                styles[item.shortName]
                              }`}
                            >
                              <div className={styles.popup_wrapper}>
                                <div className={styles.country_link}>
                                  {item.name}
                                </div>
                              </div>
                              <ReactSVG
                                className={styles.location_on}
                                src={getAssets("assets/icons/location_on.svg")}
                              />
                            </div>
                          );
                        }
                      })}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className={styles.right_side}>
            {!isMobile && <NewsSearch />}
            <NewsSubscription />
            {popularStories && popularStories?.length > 0 && (
              <NewsPopular data={popularStories} />
            )}
            {tagsList && tagsList.length > 0 && (
              <NewsTags format={format} tagsList={tagsList} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsListSection;
